function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    }
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.036,
    height: 18.036,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.246,9.018l5.424,5.424l-1.228,1.228l-5.424,-5.424l-5.424,5.423l-1.229,-1.229l2.811,-2.809l2.613,-2.613l-5.424,-5.424l1.229,-1.229l5.424,5.424l5.422,-5.424l1.229,1.229c-1.808,1.808 -3.615,3.616 -5.423,5.424Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
export default SvgX;